import { Avatar, Chip, Typography } from '@mui/material';
import React from 'react';
import { getCardColors } from '../../utils/common';
import { CourseType } from '../../types/course';
import { SkilllevelsType } from '../../types/levels';
import { LevelIconSelector } from '../../utils/select-level-icon';

const DifficultyLevelChip = ({
  courseType,
  level,
  highlighted,
  colors,
}: {
  courseType: CourseType;
  level: SkilllevelsType;
  highlighted: boolean;
  colors: { text: string; bg: string };
}) => {
  if (!level) return <></>;
  return (
    <Chip
      size="small"
      label={
        <Typography variant="button-s" className="capitalize ml-1">
          {level}
        </Typography>
      }
      avatar={
        <Avatar src={LevelIconSelector(level, courseType, highlighted)} sx={{ borderRadius: 0 }} />
      }
      sx={{
        background: colors?.bg,
        color: colors?.text,
      }}
    />
  );
};

export default DifficultyLevelChip;
